export default __webpack_public_path__ + "images/38e27f4485a388a8a0f13788d9c5adce-eric-goldie.webp";